import React from "react";
import ProjectCaseStudyTemplate from "./ProjectCaseStudyTemplate.tsx";
import padpalData from "./padpalData.tsx";

function PadPalPage() {
    return <ProjectCaseStudyTemplate data={padpalData} />;
}

export default PadPalPage;
